import firebase from '../firebase';
import FiresaleView from './FiresaleView';
import LogIn from '../Components/LogIn';

import 'firebase/firestore';
import 'firebase/auth';

import { useAuthState } from 'react-firebase-hooks/auth';

const auth = firebase.auth();
//const firestore = firebase.firestore();



function LogInView() {
    const [user] = useAuthState(auth);

    return (
        <div>
            {user ? <FiresaleView /> : <LogIn />}
        </div>
    )
}

export default LogInView;